module.exports = __webpack_public_path__ + "img/bo.eab17936.svg";